import { Module, IOrganisation } from '@bciti/types';
import { Observable } from 'rxjs';

export abstract class OrganisationService {
    abstract getOrganisations(): Observable<IOrganisation[]>;
    abstract getAvailableModules(): Observable<{ modules: Module[] }>;
    abstract getOrganisationByTag(tag: string): Observable<IOrganisation>;
    abstract uploadLogo(file: any): Observable<string>;
    abstract updateOrganisation(tag: string, organisation: Partial<IOrganisation>): Observable<IOrganisation>;
}
